export function shouldGenerateEinvoiceOnSave(config, inputs) {
    if (!config || !config.enabled) {
        return false;
    }
    return Boolean(inputs && inputs.is_einvoice_needed);
}
